import { api } from '@/services/api/client';
import type { ReviewLink, ReviewLinkNote } from './types';

/**
 * Review links for the signed-in lab.
 *
 * Paths are relative to the user surface, like every other service. They live
 * here rather than in `config/api.ts` so the feature stays in its own folder.
 *
 * As everywhere else, no call names the organisation: the server takes it from
 * the token, and answers 404 for a link that belongs to another lab.
 */
const BASE = '/review-links';

export const reviewLinksService = {
  list(signal?: AbortSignal): Promise<ReviewLink[]> {
    return api.get<ReviewLink[]>(BASE, signal ? { signal } : {});
  },

  /** Adds 30 days; an expired link re-opens for 30 days from now. */
  extend(id: string): Promise<{ id: string; expiresAt: string }> {
    return api.post(`${BASE}/${id}/extend`);
  },

  /** Mails the same link to the same dentist again. */
  resend(id: string): Promise<void> {
    return api.post(`${BASE}/${id}/resend`);
  },

  /** The dentist's comments on the design, oldest first. */
  notes(id: string, signal?: AbortSignal): Promise<ReviewLinkNote[]> {
    return api.get<ReviewLinkNote[]>(`${BASE}/${id}/notes`, signal ? { signal } : {});
  },

  /** The dentist's link stops working at once. Cannot be undone. */
  revoke(id: string): Promise<void> {
    return api.post(`${BASE}/${id}/revoke`);
  },
};
